import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { CodeInputModule } from 'angular-code-input';
import { CommonModule as BluecrewCommonModule } from '../common/common.module';
import { AccountRoutingModule } from './account-routing.module';
import { SigninComponent } from './signin/signin.component';
import { RegisterComponent } from './register/register.component';
import { IonicModule } from '@ionic/angular';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { VerificationCodeComponent } from './verification-code/verification-code.component';
import { AccountViewVerificationCodeComponent } from './account-view-verification-code/account-view-verification-code.component';
import { ResendCodeComponent } from './resend-code/resend-code.component';
import { DeleteComponent } from './delete/delete.component';
import { ForgotPasswordSubmitComponent } from './forgot-password-submit/forgot-password-submit.component';

@NgModule({
    declarations: [
        DeleteComponent,
        ForgotPasswordComponent,
        ForgotPasswordSubmitComponent,
        RegisterComponent,
        SigninComponent,
        VerificationCodeComponent,
        AccountViewVerificationCodeComponent,
        ResendCodeComponent,
    ],
    imports: [
        CodeInputModule,
        CommonModule,
        ReactiveFormsModule,
        AccountRoutingModule,
        IonicModule,
        BluecrewCommonModule,
    ]
})
export class AccountModule {}
